import type { ComponentProps } from 'react'
import { Link as RouterLink, useViewTransitionState } from 'react-router-dom'

// Every in-app link opts into the browser's View Transitions API (a no-op
// where it's unsupported -- navigation is just instant there).
export function Link(props: ComponentProps<typeof RouterLink>) {
  return <RouterLink viewTransition {...props} />
}

// An instructor's avatar morphs between the places it appears (list tile,
// carousel card, dashboard row, detail hero). `view-transition-name` must
// be unique per page or the browser cancels the whole transition, so only
// the avatar whose link is actually being navigated gets the name --
// useViewTransitionState is true just for that link, and `enabled` lets a
// caller drop the name where the same instructor appears twice on a page.
export function useSharedAvatarStyle(to: string, id: string, enabled = true) {
  const active = useViewTransitionState(to)
  return active && enabled ? { viewTransitionName: `avatar-${id}` } : undefined
}

export function instructorPath(id: string) {
  return `/instructors/${id}`
}

// Travels with the navigation so the detail page can paint the instructor's
// name and photo immediately, before its own data request returns.
export interface InstructorPreview {
  name: string
  image_url: string | null
}
export function instructorLinkState(name: string, image_url: string | null) {
  return { instructor: { name, image_url } satisfies InstructorPreview }
}
